module.exports = __webpack_public_path__ + "static/media/自我肯定-350.ae341115.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/自我肯定-350.gif
// module id = 286
// module chunks = 0